import { Brain, ChevronDown } from "lucide-react";
import { useState } from "react";

interface ReasoningBlockProps {
  text: string;
  defaultOpen?: boolean;
  /** While streaming, show last 3 lines as preview */
  streaming?: boolean;
}

export function ReasoningBlock({
  text,
  defaultOpen = false,
  streaming = false,
}: ReasoningBlockProps) {
  const [open, setOpen] = useState(defaultOpen);

  // While streaming, show last 3 lines as a live preview
  const previewLines =
    streaming && !open ? text.split("\n").filter(Boolean).slice(-3).join("\n") : null;

  return (
    <div className="mt-1 text-[11px]">
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        className="flex items-center gap-1 text-muted-foreground hover:text-foreground transition-colors"
      >
        <Brain className="w-3 h-3" />
        <span>{streaming ? "Thinking..." : "Thinking"}</span>
        <ChevronDown className={`w-3 h-3 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>

      {/* Streaming preview (collapsed, last 3 lines) */}
      {previewLines && !open && (
        <div className="mt-1 pl-3 border-l-2 border-muted-foreground/20 text-muted-foreground/60 text-[10px] leading-relaxed line-clamp-3 italic">
          {previewLines}
        </div>
      )}

      {/* Full content (expanded) */}
      {open && (
        <div className="mt-1 pl-3 border-l-2 border-muted-foreground/30 text-muted-foreground whitespace-pre-wrap leading-relaxed text-[10px] max-h-[200px] overflow-y-auto">
          {text}
        </div>
      )}
    </div>
  );
}
